/**
 * View component for /admin/authoring/scenes/new
 *
 * Creates a new scene from a copy of the defaultItem in the scene reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { history, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as sceneActions from '../sceneActions';

// import global components
import AlertModal from "../../../global/components/modals/AlertModal.js.jsx";
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from "../../../global/components/routing/Breadcrumbs.js.jsx";

// import scene components
import SceneForm from '../components/SceneForm.js.jsx';

class AdminCreateScene extends Base {
  constructor(props) {
    super(props);
    this.state = {
      alertMessage: ''
      , formHelpers: {
        hasMediaType: null
        , isNewDescriptionContent: true
        , isNewDescriptionContent: true
        , isNewTranscriptContent: true
      }
      , isAlertModalOpen: false
      , scene: { ...this.props.defaultScene }
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_addSceneTrack'
      , '_deleteTrack'
      , '_handleFormChange'
      , '_handleFormSubmit'
      , '_handleTrackFormChange'
      , '_toggleAlertModal'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newState = _.update( this.state, e.target.name, function() {
      return e.target.value;
    });
    // RichText content
    if(e.target.name === "scene.chart") {
      newState.formHelpers.isNewChartContent = false;
    }
    if(e.target.name === "scene.description") {
      newState.formHelpers.isNewDescriptionContent = false;
    }
    if(e.target.name === "scene.transcript") {
      newState.formHelpers.isNewTranscriptContent = false;
    }
    // Scenes should have a video OR a pdf. Never both.
    if(e.target.name === "scene.videoPath" && e.target.value) {
      newState.scene.pdfPath = ''
    }
    if(e.target.name === "scene.pdfPath" && e.target.value) {
      newState.scene.videoPath = ''
    }
    this.setState(newState);
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    const { formHelpers } = this.state;
    e.preventDefault();
    let scene = _.cloneDeep(this.state.scene);
    if(!formHelpers.hasMediaType) {
      scene.pdfPath = ''
      scene.videoPath = ''
    }
    dispatch(sceneActions.sendCreateScene(scene)).then((action) => {
      if(action.success) {
        dispatch(sceneActions.invalidateList());
        history.push(`/admin/authoring/scenes/${action.item._id}`);
      } else {
        // console.log("Response Error:");
        // console.log(action);
        // alert("ERROR: "+action.error);
        this._toggleAlertModal(action.error);
      }
    });
  }

  _addSceneTrack() {
    let currentTrackList = this.state.scene.tracks;
    currentTrackList.push({ file: '', label: '' });
    this._handleFormChange({
      target: {
        name: "tracks"
        , value: currentTrackList
      }
    });
  }

  _deleteTrack(index) {
    let nextTrackList = this.state.scene.tracks;
    nextTrackList.splice(index, 1);
    this._handleFormChange({
      target: {
        name: "tracks"
        , value: nextTrackList
      }
    });
  }

  _handleTrackFormChange(e, index) {
    let nextTrackList = this.state.scene.tracks;
    if(e.name && e.value) {
      nextTrackList[index][e.name] = e.value;
    } else {
      nextTrackList[index][e.target.name] = e.target.value;
    }
    this._handleFormChange({
      target: {
        name: "tracks"
        , value: nextTrackList
      }
    });
  }

  _toggleAlertModal(message) {
    this.setState({
      alertMessage: message || ''
      , isAlertModalOpen: !this.state.isAlertModalOpen
    });
  }

  render() {
    const { location } = this.props;
    const { formHelpers, scene } = this.state;
    const isEmpty = (scene.title === null || scene.title === undefined);
    return (
      <AuthoringLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
            </div>
            { isEmpty ?
              <h2> Loading...</h2>
              :
              <SceneForm
                addSceneTrack={this._addSceneTrack}
                cancelLink="/admin/authoring/scenes"
                deleteTrack={this._deleteTrack}
                formHelpers={formHelpers}
                formTitle="Create Scene"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                handleTrackFormChange={this._handleTrackFormChange}
                scene={scene}
                />
            }
          </section>
          <AlertModal
            alertMessage={this.state.alertMessage}
            alertTitle={"Error!"}
            closeAction={this._toggleAlertModal}
            confirmAction={this._toggleAlertModal}
            confirmText={"Try Again"}
            isOpen={this.state.isAlertModalOpen}
            type="danger"
            />
        </div>
      </AuthoringLayout>
    )
  }
}

AdminCreateScene.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultScene: store.scene.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminCreateScene)
);



// WEBPACK FOOTER //
// modules/scene/views/AdminCreateScene.js.jsx